import { handleFetchResponse } from '@noths/polaris-client-utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import fetch from 'isomorphic-fetch';
import getConfig from 'next/config';
import qs, { ParsedUrlQueryInput } from 'querystring';

import { NextConfig, Review, ReviewPagination } from 'src/types';
import { ReduxApplicationState } from '../combinedReducer';

const { publicRuntimeConfig } = getConfig() as NextConfig;
const RAR_DATA_ENDPOINT = publicRuntimeConfig.endpoints.rarData;

export interface ProductReviewsAPIResponse {
  pagination: ReviewPagination;
  reviews: Review[];
}

export interface RequestProductReviewsOptions {
  query?: ParsedUrlQueryInput;
}

export const requestProductReviews = createAsyncThunk<
  ProductReviewsAPIResponse,
  RequestProductReviewsOptions
>('productReviews/requestProductReviews', async ({ query }, { getState }) => {
  const { product } = getState() as ReduxApplicationState;
  const querystring = qs.encode({
    page: 1,
    perPage: 3,
    ...query,
  });

  const apiResponse = await fetch(`${RAR_DATA_ENDPOINT}${product.code}?${querystring}`);

  const { pagination, reviews }: ProductReviewsAPIResponse = await handleFetchResponse(apiResponse);

  return { pagination, reviews };
});
